export const SCORING_HANDICAP = "handicap";
export const SCORING_SCRATCH = "scratch";

/** Stored when Scoring is Scratch so every bowler gets 0 handicap pins. */
export const SCRATCH_HANDICAP_BASE = 200;
export const SCRATCH_HANDICAP_PERCENTAGE = 0;

const hasValue = (value) => value !== "" && value != null;

export const isScratchTournament = (row) =>
  Number(row?.handicapPercentage) === 0;

export const scoringTypeFromRow = (row) =>
  isScratchTournament(row) ? SCORING_SCRATCH : SCORING_HANDICAP;

export const parseOptionalHandicapMax = (value) => {
  if (!hasValue(value)) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const handicapValuesForSave = ({
  scoringType,
  handicapBase,
  handicapPercentage,
  handicapMax,
}) => {
  if (scoringType === SCORING_SCRATCH) {
    return {
      handicapBase: SCRATCH_HANDICAP_BASE,
      handicapPercentage: SCRATCH_HANDICAP_PERCENTAGE,
      handicapMax: null,
    };
  }
  return {
    handicapBase: Number(handicapBase),
    handicapPercentage: Number(handicapPercentage),
    handicapMax: parseOptionalHandicapMax(handicapMax),
  };
};

export const handicapFieldsFromRow = (row) => {
  if (isScratchTournament(row)) {
    return {
      scoringType: SCORING_SCRATCH,
      handicapBase: "",
      handicapPercentage: "",
      handicapMax: "",
    };
  }
  return {
    scoringType: SCORING_HANDICAP,
    handicapBase: row?.handicapBase ?? "",
    handicapPercentage: row?.handicapPercentage ?? "",
    handicapMax: row?.handicapMax ?? "",
  };
};

export const formatTournamentHandicap = (row) => {
  if (row == null) return "Not set";
  if (
    row.handicapBase == null &&
    row.handicapPercentage == null &&
    row.handicapMax == null
  ) {
    return "Not set";
  }
  if (isScratchTournament(row)) return "Scratch";
  const formula = `${row.handicapPercentage ?? "—"}% of ${
    row.handicapBase ?? "—"
  }`;
  if (row.handicapMax == null || row.handicapMax === "") return formula;
  return `${formula} with a max of ${row.handicapMax}`;
};
